module.exports = __webpack_public_path__ + "img/bth_bed2_left_nor.2a5ffc30.png";